import React, { useState, useEffect, useCallback } from "react";
import HeaderDemoAccountDashboard from "../components/layout/header/HeaderDemoAccountDashboard";
import DemoAccountFund from "../components/fund/DemoAccountFund";
import DemoAccInvoiceModal from "../components/modals/DemoAccInvoiceModal";
import { useNavigate } from "react-router-dom";
import "./../assets/scss/home.scss";
import { demoAccount } from "../locales/en";
import { DEMO_ACCOUNT_INVOICES } from "../route/paths";

function DemoAccountHome() {
  const navigate = useNavigate();
  const [demoInfoModal, setDemoInfoModal] = useState(true);
  const [showAlert, setShowAlert] = useState(false);

  const userData = localStorage.getItem("fundTap_demoUser_account_setup");
  const parsedData = userData ? JSON.parse(userData) : null;
  const userId = parsedData?.id;

  const HEARTBEAT_INTERVAL = 15 * 60 * 1000;
  const TABLE_MODAL_KEY = "demoInvInfoModalTimestamp";

  // Check whether the modal should be shown based on the timestamp
  const checkModalVisibility = useCallback(() => {
    const lastClosedTimestamp = localStorage.getItem(TABLE_MODAL_KEY);
    const currentTime = Date.now();

    if (
      !lastClosedTimestamp ||
      currentTime - parseInt(lastClosedTimestamp, 10) >= HEARTBEAT_INTERVAL
    ) {
      setDemoInfoModal(true);
      setShowAlert(false);
    } else {
      setDemoInfoModal(false);
      setShowAlert(true);
    }
  }, [HEARTBEAT_INTERVAL]);

  const handleHideInfoModal = () => {
    setDemoInfoModal(!demoInfoModal);
    setShowAlert(true);
    localStorage.setItem(TABLE_MODAL_KEY, Date.now().toString());
  };

  useEffect(() => {
    checkModalVisibility();
    const heartbeat = setInterval(checkModalVisibility, HEARTBEAT_INTERVAL);
    return () => clearInterval(heartbeat);
  }, [HEARTBEAT_INTERVAL, checkModalVisibility]);

  useEffect(() => {
    if (!userData || !userId) {
      navigate(DEMO_ACCOUNT_INVOICES);
    }
  }, [userData, userId, navigate]);

  return (
    <>
      <HeaderDemoAccountDashboard />
      <div className="home-main-section">
        {showAlert && (
          <div className="alert-message-wrap-blog mb-3">
            <div className="alert-message-wrap">
              <button
                className="close-alert-btn"
                onClick={() => setShowAlert(false)}
              >
                X
              </button>
              <p>{demoAccount.p1}</p>
              <p>{demoAccount.p2}</p>
            </div>
          </div>
        )}
        <div className="container">
          <div className="home-title">
            <h1>{demoAccount.title}</h1>
          </div>
        </div>
        <DemoAccountFund />
      </div>

      <DemoAccInvoiceModal
        isOpen={demoInfoModal}
        toggle={handleHideInfoModal}
      />
    </>
  );
}
export default DemoAccountHome;
